import { render, staticRenderFns } from "./DownloadIconNew.vue?vue&type=template&id=7f3946ca"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f3946ca')) {
      api.createRecord('7f3946ca', component.options)
    } else {
      api.reload('7f3946ca', component.options)
    }
    module.hot.accept("./DownloadIconNew.vue?vue&type=template&id=7f3946ca", function () {
      api.rerender('7f3946ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/DownloadIconNew.vue"
export default component.exports